import React, { useState, memo } from "react";
import "./index.css";
import SideMenuComponentsHeader from "../../GenericComponents/Headers/SideMenuComponentsHeader";
import CustomDateRangeFilter from "../../GenericComponents/CustomDateRangeFilter";
import { Row, Col, Container } from "react-bootstrap";
import { Chart } from "react-google-charts";
import { validateToken, callApi } from "../../../lib/utils";
import moment from "moment";
import PulseLoader from "react-spinners/PulseLoader";
import { useSelector } from "react-redux";
import { unionBy } from "lodash";

const AbnormalMotionGraphReports = ({ handleParams }) => {
  const [barGraphData, setBarGraphData] = useState([]);
  const [abnormalMotionEventsMaxValue, setAbnormalMotionEventsMaxValue] =
    useState(0);
  const [pieChartData, setPieChartData] = useState([]);
  const [interval, setInterval] = useState("week");
  const [IsAnyValueExistsForDayNight, setIsAnyValueExistsForDayNight] =
    useState(false);
  const [IsAnyValueExistsForLineChart, setIsAnyValueExistsForLineChart] =
    useState(false);
  const [IsAnyValueExistsForBarChart, setIsAnyValueExistsForBarChart] =
    useState(false);
  const [lineChartData, setLineChartData] = useState([]);
  //const [lineChartInterval, setLineChartInterval] = useState("");
  const [boxchartData, setBoxChartData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({});
  const profileData = useSelector((state) => state?.dashboard);

  const generateDateArray = (startDateStr, endDateStr)=> {
  const startDate = moment(startDateStr);
  const endDate = moment(endDateStr);
  const dateArray = [];

  // Check if startDate is before or equal to endDate
  if (startDate.isAfter(endDate)) {
    return dateArray; // Return an empty array if start date is after end date
  }

  while (startDate.isSameOrBefore(endDate)) {
    dateArray.push(startDate.format('YYYY-MM-DD'));
    startDate.add(1, 'days'); // Increment startDate by 1 day
  }

  return dateArray;
}

const injectMissingEventDates = (events, startDate, endDate) => {
  const updatedEvents = [];
  
  const dateArray = generateDateArray(startDate, endDate);
  for (const date of dateArray) {
    updatedEvents.push({
      "timestamp": moment(date).valueOf(),
      "duration": 0,
      "date":moment(date).format(
        "MMM DD hh:mm A"
      )
    });
  }
  // for (const event of events) {
  //   const { timestamp, duration } = event;
  //   const dateArray = generateDateArray(timestamp, endDate);
    
  //   for (const date of dateArray) {
  //     updatedEvents.push({
  //       date,
  //       duration
  //     });
  //   }
  // }

  return updatedEvents;
}

// // Example usage:
// const events = [
//   { startDate: '2023-09-01', endDate: '2023-09-03', duration: '2 hours' },
//   { startDate: '2023-09-05', endDate: '2023-09-06', duration: '1 hour' }
// ];

// const updatedEvents = injectMissingEventDates(events);


// const getDatesInRange = (startDate, endDate,lineChartArray) => {
//     let dtObject = {};

//     lineChartArray.sort((a, b) => {
//         if (a.timestamp < b.timestamp) return -1;
//         if (a.timestamp > b.timestamp) return 1;

//         return 0;
//       })
//       .forEach((dt) => {
//         if (
//           Object.keys(dtObject).includes(
//             moment(dt.timestamp).format("DDMMYYYY")
//           )
//         ) {
//           dtObject[moment(dt.timestamp).format("DDMMYYYY")].push(dt);
//         } else {
//           dtObject[moment(dt.timestamp).format("DDMMYYYY")] = [dt];
//         }
//       });

//     let graphData = [];

//     while (startDate.isSameOrBefore(endDate)) {
//       if (Object.keys(dtObject).includes(startDate.format("DDMMYYYY"))) {
//         graphData.push(...dtObject[startDate.format("DDMMYYYY")]);
//       } else {
//         graphData.push({
//           timestamp: startDate.valueOf(),
//           duration: null,
//         });
//       }
//       startDate = startDate.add(1, "day");
//     }

//     console.log("graphData: ", graphData);
//   };
  const fetchData = (startDate, endDate, interval) => {
    const params = {
      patientId: null,
      start: moment(startDate).valueOf(),
      end: moment(endDate).valueOf(),
      interval: interval,
      timezone: moment.tz.guess(),
      page: 1,
      limit: 20,
    };
    setParams(params);
    setLoading(true);
    callApi(
      `/api/reports/patient/event/abnormal-motion/intervals`,
      params,
      "POST"
    )
      .then((response2) => {
        const duration = response2?.data?.data?.amEventsDuration;
        if (duration?.length) {
          duration.unshift(profileData?.profileData?.patientData?.firstName);
          setBoxChartData([duration]);
          setLoading(false);
        } else {
          setBoxChartData([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
    callApi(`/api/reports/patient/event/abnormal-motion`, params, "POST")
      .then((response) => {
        const intervalWiseEventClassification =
          response?.data?.data?.intervalWiseEventClassification;
        const event_time_classification =
          response?.data?.data?.eventTimeClassification;
        const pieChartArray = [[interval, "Number Of Events"]];
        let temp = [
          [interval, "Not Classified", "Actual", { role: "annotation" }],
        ];
        let isDayNight = false;
        //let isIntervalWiseEvents = false;
        Object.keys(intervalWiseEventClassification).map((key) => {
          const eventDate = moment(parseInt(key)).format(
            interval === "month" ? "MMM YYYY" : "MMM DD"
          );
          //moment(key).format('MM/DD/YYYY');
          //const numberOfEvents = intervalWiseEventClassification[key];
          const notClassified =
            intervalWiseEventClassification[key]["notClassified"];
          const actual = intervalWiseEventClassification[key]["actual"];
          const total = intervalWiseEventClassification[key]["total"];
          // if (!isIntervalWiseEvents) {
          //   isIntervalWiseEvents = !!numberOfEvents;
          // }
          temp.push([eventDate, notClassified, actual, total]);
        });

        Object.keys(event_time_classification).map((key) => {
          const numberOfEvents = event_time_classification[key];
          if (!isDayNight) {
            isDayNight = !!numberOfEvents;
          }
          pieChartArray.push([
            key === "dayTimeEvents" ? "Day Time Events" : "Night Time Events",
            numberOfEvents,
          ]);
        });
        let maxValue = temp.reduce((arr, current) => {
          if (Array.isArray(arr) && !!arr?.includes("Actual")) {
            return current?.length ? current[3] : 0;
          }
          return (arr = arr > current[3] ? arr : current[3]);
        });

        if (maxValue <= 5) {
          maxValue = maxValue + 5;
        } else {
          maxValue = maxValue + 10;
        }
        setAbnormalMotionEventsMaxValue(maxValue);

        setBarGraphData(temp);
      
        setLoading(false);
        setInterval(interval);
        setPieChartData(pieChartArray);
        setIsAnyValueExistsForDayNight(isDayNight);
        setIsAnyValueExistsForBarChart(temp?.length >= 2);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
    callApi(
      `/api/reports/patient/event/abnormal-motion/time-lag`,
      params,
      "POST"
    )
      .then((response1) => {
        const seizureFreeDays = response1?.data?.data?.timeLag;
        // //setLineChartInterval(
        //   response1?.data?.data?.timeLag
        // );
        const lineChartArray = [["Event Date", "Event Duration", " ", "", ""]];
        let isSeizureFreeDaysCount = false;
        //getDatesInRange(d1, d2,lineChartArray);
        const temp = seizureFreeDays.map((item)=>{
          item['date'] = moment(parseInt(item?.timestamp)).format(
            "MMM DD hh:mm A"
          );
          return item;
        })
        const seizureFreeDaysTemp = injectMissingEventDates(seizureFreeDays, moment(seizureFreeDays[0].timestamp).startOf("day"), params?.end);
        const result = unionBy(temp,seizureFreeDaysTemp, "date");
        //console.log('updatedEvents', result);
        //console.log('updatedEvents', seizureFreeDaysTemp);
       // console.log('seizureFreeDaysTemp', seizureFreeDaysTemp);
        //console.log('seizureFreeDays', seizureFreeDays);
        let lastDuration = null;
        result.sort((a, b) => {
          if (a.timestamp < b.timestamp) return -1;
          if (a.timestamp > b.timestamp) return 1;
          return 0;
        }).map((key, index) => {
          const numberOfseizureFreecount = key?.duration===0?null:key?.duration;
          if(!!numberOfseizureFreecount){
            lastDuration = numberOfseizureFreecount
          }
          const eventDate = moment(parseInt(key?.timestamp)).format(
            "MMM DD hh:mm A"
          );
          lineChartArray.push([
            eventDate,
            lastDuration,
            numberOfseizureFreecount,
            numberOfseizureFreecount?0:null,
            0,
          ]);
          isSeizureFreeDaysCount = true;
        });
        setLineChartData(lineChartArray);
        
        setIsAnyValueExistsForLineChart(isSeizureFreeDaysCount);
      })
      .catch((err) => {
        console.log("err: ", err);
      });

    handleParams(params);
  };
  const handleDateRange = (selection, interval) => {
    validateToken((err) => {
      if (err) {
        window.location = "/logout";
      }
      fetchData(selection?.startDate, selection?.endDate, interval);
    });
  };
  const options = {
    title: "No. Of Motion Monitoring Events",
    annotations: {
      alwaysOutside: true,
      textStyle: {
        fontSize: 14,
        color: "#000",
        auraColor: "none",
      },
    },
    width: "100%",
    height: 400,
    legend: { maxLines: 10, position: "bottom" },
    bar: { groupWidth: "75%" },
    isStacked: true,
    series: {
      0: { color: "#E38416", format: "0" },
      1: { color: "#1D9233", format: "0" },
    },
    vAxis: { format: "0", minValue: 0, maxValue: abnormalMotionEventsMaxValue },
  };
  // const options = {
  //   title: "No. Of Abnormal Motion Events",
  //   isStacked: true,
  //   legend: { position: 'top', maxLines: 3 },
  //   bar: { groupWidth: '75%' },
  //   hAxis: {
  //     title: interval,
  //   },
  //   vAxis: {
  //     title: "Number Of Seizure Episods",
  //     format: "0",
  //   },
  // };

  const pieOptions = {
    title: "Day Time And Night Time Events ",
    is3D: true,
    colors: ["#0CAFFF", "#3366cc"],
  };

  const lineOptions = {
    title: "Time Lag Between Consecutive Events",
    legend: "none",
    seriesType: "line",
    series: {
      1: { type: "scatter", color: "#3366cc" },
      2: { type: "scatter", color: "#E38416" },
      3: { color: "#E38416" },
    },
    vAxis: {
      // title: "Time lag ( In " + lineChartInterval + " )",
      title: "Motion Monitoring Event Duration In Sec",
      format: "0",
    },
    hAxis: {
      title: "lag time between events",
    },
    tooltip: { isHtml: true },
  };

  const BoxPlotGraph = ({ boxchartData }) => {
    const dynamicDataInit = [];
    boxchartData[0].map((item, index) => {
      if (index !== 0) {
        dynamicDataInit.push({ type: "number", label: "Series" + (index - 1) });
      }
    });
    let dataInit = [
      [
        { type: "string", label: "x" },
        ...dynamicDataInit,
        { id: "max", type: "number", role: "interval", label: "max" },
        { id: "min", type: "number", role: "interval", label: "min" },
        {
          id: "firstQuartile",
          type: "number",
          role: "interval",
          label: "first quartile",
        },
        { id: "median", type: "number", role: "interval", label: "median" },
        {
          id: "thirdQuartile",
          type: "number",
          role: "interval",
          label: "third quartile",
        },
        // { role: "annotation", style: { color: "green" } },
        // { role: "annotation" },
        // { role: "annotation" },
      ],
    ];
    const getBoxPlotValues = (param) => {
      let array = [[...param[0]]];
      for (let i = 0; i < param.length; i++) {
        let arr = array[i].slice(1).sort(function (a, b) {
          return a - b;
        });

        let max = arr[arr.length - 1];
        let min = arr[0];
        let median = getMedian(arr);

        // First Quartile is the median from lowest to overall median.
        let firstQuartile = getMedian(arr.slice(0, arr.length / 2));

        // Third Quartile is the median from the overall median to the highest.
        let thirdQuartile = getMedian(arr.slice(arr.length / 2 + 1));

        array[i][arr.length + 1] = max;
        array[i][arr.length + 2] = min;
        array[i][arr.length + 3] = firstQuartile;
        array[i][arr.length + 4] = median;
        array[i][arr.length + 5] = thirdQuartile;
        // array[i][arr.length + 6] = "min";
        // array[i][arr.length + 7] = "median";
        // array[i][arr.length + 8] = "max";
      }
      return array;
    };
    /*
     * Takes an array and returns
     * the median value.
     */
    const getMedian = (array) => {
      const length = array.length;

      /* If the array is an even length the
       * median is the average of the two
       * middle-most values. Otherwise the
       * median is the middle-most value.
       */
      if (length % 2 === 0) {
        const midUpper = length / 2;
        const midLower = midUpper - 1;

        return (array[midUpper] + array[midLower]) / 2;
      } else {
        return array[Math.floor(length / 2)];
      }
    };
    const data = boxchartData?.length
      ? [...dataInit, ...getBoxPlotValues(boxchartData)]
      : [];

    const options = {
      displayAnnotations: true,
      title: "Event Distribution Summary Statistics",
      height: 500,
      legend: { position: "none" },
      hAxis: {
        title: "",
        gridlines: { color: "#fff" },
        role: "style",
      },
      vAxis: {
        title: "Total Motion Monitoring Event Duration(In Sec)",
        format: "0",
      },
      lineWidth: 0,
      //{ color: "#D3362D" },
      series: [{ color: "black", visibleInLegend: false }],
      intervals: {
        barWidth: 0.5,
        boxWidth: 1,
        lineWidth: 2,
        style: "boxes",
      },
      interval: {
        max: {
          style: "bars",
          fillOpacity: 1,
          color: "#777",
          title: "Max",
          role: "annotations",
        },
        min: {
          style: "bars",
          fillOpacity: 1,
          color: "#777",
          title: "Min",
        },
      },
      trendlines: {
        0: {
          type: "linear",
          color: "green",
          lineWidth: 3,
          opacity: 0.3,
          showR2: true,
          visibleInLegend: true,
        },
      },
    };

    return (
      <Chart
        chartType="LineChart"
        width="100%"
        height="400px"
        data={data}
        options={options}
      />
    );
  };

  return (
    <>
      <SideMenuComponentsHeader title="Motion Monitoring Events Report" />
      <div
        className="date-filter"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          margin: "16px 8px 0 0",
        }}
      >
        <CustomDateRangeFilter onChange={handleDateRange} isByInterval={true} />
      </div>

      <div className="chart-container" style={{ marginBottom: "100px" }}>
        <Row>
          <Col md={6}>
            {loading ? (
              <div className="pulse-loader-container">
                <PulseLoader
                  color={"#70757a"}
                  loading={loading}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            ) : (
              <div className="bar-chart-container">
                {!loading && IsAnyValueExistsForBarChart ? (
                  <Chart
                    //chartType="Bar"
                    chartType="ColumnChart"
                    width="100%"
                    height="400px"
                    data={barGraphData}
                    options={options}
                  />
                ) : (
                  <>
                    <div className="bar-chart-header-container">
                      {" "}
                      No. Of Motion Monitoring Events{" "}
                    </div>
                    <div className="no-data-found-container">
                      Required Data is not available to plot chart
                    </div>
                  </>
                )}
              </div>
            )}
          </Col>
          <Col md={6}>
            {loading ? (
              <div className="pulse-loader-container">
                <PulseLoader
                  color={"#70757a"}
                  loading={loading}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            ) : (
              <div className="bar-chart-container">
                {!loading && IsAnyValueExistsForDayNight ? (
                  <Chart
                    chartType="PieChart"
                    data={pieChartData}
                    options={pieOptions}
                    width={"100%"}
                    height={"400px"}
                  />
                ) : (
                  <>
                    <div className="bar-chart-header-container">
                      {" "}
                      Day Time And Night Time Events{" "}
                    </div>
                    <div className="no-data-found-container">
                      Required Data is not available to plot Chart
                    </div>
                  </>
                )}
              </div>
            )}
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            {loading ? (
              <div className="pulse-loader-container">
                <PulseLoader
                  color={"#70757a"}
                  loading={loading}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            ) : (
              <div className="bar-chart-container">
                {!loading && IsAnyValueExistsForLineChart ? (
                  <Chart
                    chartType="ComboChart"
                    width="100%"
                    height="400px"
                    data={lineChartData}
                    options={lineOptions}
                  />
                ) : (
                  <>
                    <div className="bar-chart-header-container">
                      Time Lag Between Consecutive Events{" "}
                    </div>{" "}
                    <div className="no-data-found-container">
                      Required Data is not available to plot Chart
                    </div>
                  </>
                )}
              </div>
            )}
          </Col>
          <Col md={6}>
            {loading ? (
              <div className="pulse-loader-container">
                <PulseLoader
                  color={"#70757a"}
                  loading={loading}
                  aria-label="Loading Spinner"
                  data-testid="loader"
                />
              </div>
            ) : (
              <div className="bar-chart-container">
                {!loading && !!boxchartData?.length ? (
                  <BoxPlotGraph boxchartData={boxchartData} />
                ) : (
                  <>
                    {" "}
                    <div className="bar-chart-header-container">
                      Event Distribution Summary Statistics
                    </div>
                    <div className="no-data-found-container">
                      Required Data is not available to plot chart
                    </div>
                  </>
                )}
              </div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default memo(AbnormalMotionGraphReports);
